module.exports = __webpack_public_path__ + "static/media/kalispell mt construction.7e8a1dd8.png";